export const state = () => ({
  track: null,
  isPlaying: false,
  volume: 1,
  isMuted: false,
  volumeBeforeMute: 1,
});
